import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "voice-modal d-flex align-items-center text-nowrap" }
const _hoisted_2 = {
  key: 0,
  class: "loader"
}
const _hoisted_3 = { class: "ml-2" }

import {__} from "~/ts/library/Translate";
import useTextareaComponent from "~/operatorApplication/vue/dialogs/dialog/textarea/useTextareaComponent";
import {ref} from "vue";
import VoiceRecorder from "~/ts/library/VoiceRecorder";
import {AbstractApiResult} from "~/core-ui/ts/request/AbstractApiResult";
import axios from "axios";
import MyLoader from "~/cabinet/vue/interface/data/MyLoader.vue";
import OperatorApiRequest from "~/operatorApplication/ts/request/OperatorApiRequest";
import {OperatorApplicationEventManager} from "~/operatorApplication/ts/OperatorApplicationEventManager";
import {getTranscribeEventId} from "~/operatorApplication/ts/service/comet/listeners/TranscribeAudioFile";


import {defineComponent} from 'vue';

const __default__ = defineComponent({
    name: "VoiceRecorder"
});

export default /*@__PURE__*/_defineComponent({
  ...__default__,
  props: /*@__PURE__*/_mergeModels({
    transcribe: { type: Boolean },
    username: {}
  }, {
    "visible": { type: Boolean },
    "visibleModifiers": {},
  }),
  emits: /*@__PURE__*/_mergeModels(["transcribe-result"], ["update:visible"]),
  setup(__props: any, { emit: __emit }) {

let props = __props;

let emits = __emit;
let {uploadVoiceAction, uploadOnChange} = useTextareaComponent();

let visible = _useModel<boolean>(__props, "visible")

let popoverVisible = ref(false);
let voiceRecorder = ref<VoiceRecorder>();

let manualStop = false;
let sendingFile = ref(false);
let transcribing = ref(false);


function stopRecord(save: boolean = false) {
    manualStop = save;
    voiceRecorder.value.stop();
    //togglePopoverVisible(false);
}

async function startRecord() {
    if (!sendingFile.value) {
        manualStop = false;

        try {
            voiceRecorder.value = (new VoiceRecorder(async result => {
                if (manualStop) {
                    sendingFile.value = true;
                    let formData = new FormData();

                    formData.append("file", result.blob, `voice.${result.format.extension}`);
                    try {
                        let postResult = (await axios.post(uploadVoiceAction.value, formData)).data;
                        if (props.transcribe) {
                            let fileId = postResult?.data?.id;
                            if (fileId) {
                                let transcribeResult = new Promise<string>(async (resolve, reject) => {
                                    transcribing.value = true;
                                    try {
                                        let p: OperatorApplicationApi.OperatorTranscribeAudioFileOpenApiModel = {
                                            fileId,
                                            username: props.username
                                        };
                                        let result = await (new OperatorApiRequest({
                                            url: "/message/transcribeAudioFile",
                                            p,
                                            silent: true
                                        })).send();
                                        result.showMessageOnError();
                                    } catch (e) {
                                        reject(e);
                                        return;
                                    }
                                    OperatorApplicationEventManager.once(getTranscribeEventId(fileId), text => {
                                        resolve(text);
                                    }, 60000, () => reject("timeout"))
                                });

                                let text = await transcribeResult;
                                if (text) {
                                    if (typeof text == "string") {
                                        emits("transcribe-result", text);
                                    }
                                }
                            } else {
                                throw new Error();
                            }
                        } else {
                            uploadOnChange({response: postResult});
                        }
                    } catch (e) {
                        console.error(e);
                        AbstractApiResult.showMessage(
                            props.transcribe ? "Не удалось распознать голос" : "Не удалось загрузить файл",
                            "error"
                        );
                    }
                    sendingFile.value = false;
                    visible.value = false;
                    transcribing.value = false;
                }
            }));
            await voiceRecorder.value.start();
            popoverVisible.value = true;
        } catch (e) {
            stopRecord();
            AbstractApiResult.showMessage(
                "Не удалось начать запись сообщения.<br /><br />Не найдено звукозаписывающее устройство, или запрещена запись звука.",
                "error",
                true
            );
            visible.value = false;
        }
    }
}

startRecord();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      (_unref(sendingFile))
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createVNode(MyLoader)
          ]))
        : (_openBlock(), _createElementBlock("div", {
            key: 1,
            class: "fixed-circle animated cursor-pointer",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (stopRecord(true)))
          }, [...(_cache[1] || (_cache[1] = [
            _createElementVNode("div", { class: "stop-icon" }, null, -1)
          ]))])),
      _createElementVNode("div", _hoisted_3, _toDisplayString(_unref(transcribing) ? _unref(__)("Идёт распознавание голоса") : _unref(__)("Запись голосового сообщения")) + "... ", 1)
    ])
  ]))
}
}

})